<template lang="html">
  <div>

    <ul v-if="docs.dpc" class="lista-downloads">
      <li class="prod">DPC - Declaração de Práticas de Certificação</li>
			<li>
        <a :href="docs.dpc"> DPC {{ nomeac }}</a>
        <span></span>
      </li>
		</ul>
    <ul v-if="docs.cps" class="lista-downloads">
      <li class="prod">CPS  - Certification Practice Statement</li>
			<li>
        <a :href="docs.cps"> CPS CA  {{ nomeac }}</a>
        <span></span>
      </li>
		</ul>
    <ul v-if="docs.kgar" class="lista-downloads">
      <li class="prod">Relatório de Auditoria - Geração de Chave</li>
			<li>
        <a :href="docs.kgar"> Key Generation Audit Report</a>
        <span></span>
      </li>
		</ul>
    <ul v-if="docs.pc" class="lista-downloads">
      <li class="prod"><span v-if="nomeac != 'ACT SOLUTI'">PC - Política de Certificado</span><span v-else>PCT - Política de Carimbo de Tempo</span></li>
			<li v-for="item in docs.pc">
        <a v-if="!item.infoName" :href="item.arquivo"> <pct v-if="nomeac != 'ACT SOLUTI'">AC {{ nomeac }} - PC {{ item.nome }}</pct><pct v-else> {{ nomeac }} - PCT {{ item.nome }} </pct> </a>
        <span>{{ item.descricao }} <tp v-if="!item.infoName">- Tipo {{ item.nome }} </tp></span>
      </li>
		</ul>

    <ul v-if="docs.ps" class="lista-downloads">
      <li class="prod">PS - Política de Segurança</li>
			<li>
        <a :href="docs.ps">PS {{ nomeac }}</a>
        <span></span>
      </li>
		</ul>

  </div>
</template>

<script>
export default {
  props: [
    'nomeac', 'docs'
  ]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RepositorioDocs.vue?72bdcb52